import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";

import { useAuth } from "../../utils/useAuth";
import { useAxios } from "../../utils/useAxios";
import { auxiliarData } from "../fhir/AuxiliarData";

export interface TissData {
  organizationId: string;
  organizationName: string;
  organizationAlias: string;
  practitionerId: string;
  practitionerName: string;
  patientId: string;
  appointmentId: string;
}

export async function PostTiss(objData: TissData, tissXML: any) {
  let url = `${endpoints.XDSB_domain}/tiss/fhir`;

  const data = auxiliarData.TissDocumentReference(objData, tissXML);

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+xml",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostDocumentReference: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostDocumentReference ", error);
      // toast.error(`PostDocumentReference Error: ${error?.response?.status}`);
      throw new Error();
    });

  if (response) return response;
}
